// TODO: Make sure admission timeslots are also loaded before showing calendar
// PromiseAll?

import axios from "axios";
import { format, addMonths, subMonths, isThisMonth } from "date-fns";

const init = () => {
	const loadingClass = "is-loading";
	const tdSelectedClass = "calendar-dates__body-cell--selected";
	const step = document.querySelector("[data-booking-step]");
	const calendar = document.querySelector("[data-calendar]");
	const startMonth = calendar.getAttribute("data-calendar-start-month"); // Month that calendar should get on page load
	const startDate = calendar.getAttribute("data-calendar-start-date"); // If showing date range, this will be the start date
	const endDate = calendar.getAttribute("data-calendar-end-date"); // If showing date range, this will be the end date
	const monthBtns = calendar.querySelectorAll("[data-month-btn]");
	const prevMonthBtn = calendar.querySelector('[data-month-btn="-"]');
	const monthName = calendar.querySelector("[data-month-name]");
	const calendarBody = calendar.querySelector("[data-calendar-body]");
	const dateFld = calendar.querySelector("[data-date-fld]");
	const timeslotsContainer = step.querySelector("[data-timeslots-container]");
	const timeslotsContainerInner = step.querySelector("[data-timeslots-container-inner]");
	const timeslotsFld = step.querySelector("[data-timeslots-fld]");
	const overviewContainer = step.querySelector("[data-overview-container]");
	const overviewContainerInner = step.querySelector("[data-overview-container-inner]");
	const siteHeaderNav = document.querySelector(".booking-overlay__actions");
	let selectedMonth = new Date(startMonth);
	let chosenTimeslot = calendar.getAttribute("data-calendar-chosen-timeslot");

	// Listen for when date selected on step
	step.addEventListener("date-selected", (e) => {
		// Dispatch event to show current step validity (in case another date chosen)
		const ev = new CustomEvent("step-validity-change", {
			bubbles: true,
			detail: false,
		});
		step.dispatchEvent(ev);

		// Clear overview
		overviewContainerInner.innerHTML = "";
		overviewContainer.classList.add(loadingClass);

		getOverview(e.detail).then((response) => {
			console.log(response);

			overviewContainerInner.innerHTML = response.data.html;

			// Dispatch event to show current step validity
			const ev = new CustomEvent("step-validity-change", {
				bubbles: true,
				detail: true,
			});
			step.dispatchEvent(ev);

			overviewContainer.classList.remove(loadingClass);
		});

		// REMOVED CODE BELOW RELATED TO SELECTING A TIMESLOT ---------------------

		// Scroll to timeslots container
		// window.scroll({
		// 	top: ((timeslotsContainer.getBoundingClientRect().top - siteHeaderNav.offsetHeight) - 20),
		// 	left: 0,
		// 	behavior: 'smooth'
		// })

		// Add loading class to timeslots component
		// timeslotsContainerInner.removeAttribute('style')
		// timeslotsContainer.classList.toggle(loadingClass)

		// Clear current timeslots options and re-select first option
		// timeslotsFld[0].disabled = false
		// timeslotsFld.length      = 1
		// timeslotsFld.value       = ''

		// Get available timeslots for selected date
		// getTimeslots(e.detail).then((response) => {

		// 	let hasValue = false

		// 	// Loop through returned available timeslots
		// 	for (const ts of response.data.data) {

		// 		// Add relevant options to timeslots field
		// 		const opt = document.createElement('option')
		// 		opt.value = ts
		// 		opt.text  = ts

		// 		timeslotsFld.add(opt, null)

		// 		if (ts === chosenTimeslot) {
		// 			hasValue = true
		// 		}
		// 	}

		// 	// Select option that matches chosen timeslot if present
		// 	if (hasValue) {
		// 		timeslotsFld.value = chosenTimeslot

		// 		// Dispatch event to show timeslot chosen
		// 		const ev = new CustomEvent('timeslot-selected', {
		// 			bubbles: true,
		// 			detail: timeslotsFld.value
		// 		})
		// 		timeslotsFld.dispatchEvent(ev)
		// 	}

		// 	// Show timeslots block
		// 	timeslotsContainer.classList.toggle(loadingClass)
		// })
	});

	// Listen for when timeslot selected
	step.addEventListener("timeslot-selected", (e) => {
		overviewContainer.classList.add(loadingClass);

		// Disable first option in timeslots field, so it can't be selected again
		timeslotsFld[0].disabled = true;

		// Get available timeslots for selected date
		getOverview(e.detail).then((response) => {
			console.log(response);

			overviewContainerInner.innerHTML = response.data.html;

			// Dispatch event to show current step validity
			const ev = new CustomEvent("step-validity-change", {
				bubbles: true,
				detail: true,
			});
			step.dispatchEvent(ev);

			overviewContainer.classList.remove(loadingClass);
		});
	});

	// Listen for when date selected
	calendar.addEventListener("date-selected", (e) => {
		console.log("date selected!");

		// Get date btn that was clicked
		const target = e.target;

		// Loop through td's in calendar and remove selected class from all
		for (const td of calendar.querySelectorAll("tbody td")) {
			td.classList.remove(tdSelectedClass);
		}

		// Add selected class to relevant td
		target.closest("td").classList.add(tdSelectedClass);

		// Add selected date to field
		dateFld.value = e.detail;
	});

	// Listen for when month changed
	calendar.addEventListener("month-changed", (e) => {
		console.log("month changed!");

		// Disable month btns until month dates returned
		for (const btn of monthBtns) {
			btn.disabled = true;
		}

		// Get direction of month change
		const dir = e.detail;

		switch (dir) {
			case "+":
				selectedMonth = addMonths(selectedMonth, 1);
				break;

			case "-":
				selectedMonth = subMonths(selectedMonth, 1);
		}

		// Show new month name
		monthName.innerHTML = format(selectedMonth, "LLLL yyyy");

		// Get dates for new month
		getMonth();
		// getMonth().then((response) => {

		// 	// Get html for dates from response
		// 	const html = response.data.html

		// 	// Add dates html into calendar
		// 	calendarBody.innerHTML = html

		// 	// Add event listeners to new dates
		// 	initCalendarDates()

		// 	// Re-enable month btns
		// 	for (const btn of monthBtns) {
		// 		btn.disabled = true
		// 	}

		// 	// Check if previous month button should be enabled/disabled
		// 	if (isThisMonth(selectedMonth)) {
		// 		prevMonthBtn.disabled = true
		// 	} else {
		// 		prevMonthBtn.disabled = false
		// 	}

		// 	// Remove loading class from calendar
		// 	calendar.classList.remove(loadingClass)
		// })
	});

	// CALENDAR MONTH NAVIGATION --------------------------------------
	for (const item of monthBtns) {
		item.addEventListener("click", (e) => {
			const target = e.target;
			const dir = target.getAttribute("data-month-btn");

			const ev = new CustomEvent("month-changed", {
				bubbles: true,
				detail: dir,
			});
			item.dispatchEvent(ev);
		});
	}

	// Add event listener to timeslots field
	// timeslotsFld.addEventListener("change", (e) => {
	// 	const ev = new CustomEvent("timeslot-selected", {
	// 		bubbles: true,
	// 		detail: timeslotsFld.value,
	// 	});
	// 	timeslotsFld.dispatchEvent(ev);
	// });

	// Adds the event listeners to dates in calendar
	const initCalendarDates = () => {
		// Loop through date buttons in current month
		for (const item of calendar.querySelectorAll("[data-date-trigger]")) {
			// On click, dispatch custom 'date-selected' event containing date string
			item.addEventListener("click", (e) => {
				const btnDate = item.getAttribute("data-date-trigger");

				// Only dispatch event if clicked date is not same as currently selected
				if (btnDate !== dateFld.value) {
					const ev = new CustomEvent("date-selected", {
						bubbles: true,
						detail: item.getAttribute("data-date-trigger"),
					});
					item.dispatchEvent(ev);
				}
			});
		}
	};

	const getMonth = () => {
		// Add loading class to calendar
		calendar.classList.add(loadingClass);

		// Remove current dates
		calendarBody.innerHTML = "";

		// Construct url to call to get dates for selected month
		const url = new URL("/data/calendar-dates", window.location.origin);

		// Url params
		url.searchParams.append("month", format(selectedMonth, "yyyy-MM")); // Month to get dates for

		// Add start and end date params if need to show specific date range
		if (startDate !== "") {
			url.searchParams.append("startDate", startDate);
		}
		if (endDate !== "") {
			url.searchParams.append("endDate", endDate);
		}

		// If date has already been selected, also pass this as a param
		if (dateFld.value !== "") {
			url.searchParams.append("selected", dateFld.value);
		}

		// Add param to cachebust results
		url.searchParams.append("cachebust", format(new Date(), "t"));

		// Ajax call
		axios.get(url.href).then((response) => {
			// Get html for dates from response
			const html = response.data.html;

			// Add dates html into calendar
			calendarBody.innerHTML = html;

			// Add event listeners to new dates
			initCalendarDates();

			// Re-enable month btns
			for (const btn of monthBtns) {
				btn.disabled = false;
			}

			// Check if previous month button should be enabled/disabled
			if (isThisMonth(selectedMonth)) {
				prevMonthBtn.disabled = true;
			} else {
				prevMonthBtn.disabled = false;
			}

			// Remove loading class from calendar
			calendar.classList.remove(loadingClass);
		});
	};

	/**
	 * Makes axios call to get available timeslots for a specific date
	 * @param string date Date in 'yyyy-mm-dd' format
	 * @returns Promise
	 */
	const getTimeslots = (date) => {
		const url = new URL("/data/daily-time-slots", window.location.origin);

		// Url params
		url.searchParams.append("date", date); // Date to get timeslots for
		url.searchParams.append("cachebust", format(new Date(), "t")); // Cachebust param

		return axios.get(url.href);
	};

	/**
	 * Makes axios call to get html for overview component in sidebar
	 * @returns Promise
	 */
	const getOverview = () => {
		// Get currently selected date and timeslot
		const date = dateFld.value;
		const timeslot = timeslotsFld.value;

		const url = new URL("/data/choose-date-overview", window.location.origin);

		// Url params
		url.searchParams.append("date", date);
		url.searchParams.append("timeslot", timeslot);
		url.searchParams.append("cachebust", format(new Date(), "t"));

		return axios.get(url.href);
	};

	// If date has already been selected...
	if (dateFld.value !== "" && timeslotsContainer) {
		// Dispatch a 'date-selected' event so the the 'step' element hears it
		const selectedDateEvent = new CustomEvent("date-selected", {
			bubbles: true,
			detail: dateFld.value,
		});
		timeslotsContainer.dispatchEvent(selectedDateEvent);
	}

	// Get dates for current month
	getMonth();
};

export default function () {
	init();
}
